<button [type]="type" mat-raised-button color="primary" *ngIf="buttonType === 'primary'" [disabled]="disabled" (click)="onClick()">
  {{ title }}
</button>

<button mat-raised-button color="primary" *ngIf="buttonType === 'secondary'"
  style="color: #990000 !important; border: 1px solid #990000 !important" [disabled]="disabled" (click)="onClick()">
  {{ title }}
</button>
